<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
      @click.native="() => handleClick(item)"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
    components: {
        VerticalNavMenuHeader,
        VerticalNavMenuLink,
        VerticalNavMenuGroup
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    setup () {
        provide('openGroups', ref([]))
        const handleClick = (item) => {
            if (!item.domain) return
            const token = localStorage.getItem('x-auth-token')
            window.open(`${item.domain}/signin/email/${item.email}/token/${token}`, '_blank')
        }
        return {
            handleClick,
            resolveNavItemComponent
        }
    }
}
</script>
